import { jsx as _jsx } from "react/jsx-runtime";
import { DfxContextProvider } from '@dfx.swiss/react';
import { SpinnerSize, StyledLoadingSpinner } from '@dfx.swiss/react-components';
import { Suspense, lazy } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Layout } from './components/layout';
import { AppHandlingContextProvider } from './contexts/app-handling.context';
import { BalanceContextProvider } from './contexts/balance.context';
import { SettingsContextProvider } from './contexts/settings.context';
import { WalletContextProvider } from './contexts/wallet.context';
import { BankAccountsScreen } from './screens/bank-accounts.screen';
import { BuyInfoScreen } from './screens/buy-info.screen';
import { BuySuccessScreen } from './screens/buy-success.screen';
import { BuyScreen } from './screens/buy.screen';
import { ErrorScreen } from './screens/error.screen';
import { HomeScreen } from './screens/home.screen';
import { KycRedirectScreen } from './screens/kyc-redirect.screen';
import { KycScreen } from './screens/kyc.screen';
import { LimitScreen } from './screens/limit.screen';
import { LinkScreen } from './screens/link.screen';
import { SellInfoScreen } from './screens/sell-info.screen';
import { SupportIssueScreen } from './screens/support-issue.screen';
import { TfaScreen } from './screens/tfa.screen';
import { TransactionScreen } from './screens/transaction.screen';
import { setupLanguages } from './translations';
const SellScreen = lazy(() => import('./screens/sell.screen'));
const SwapScreen = lazy(() => import('./screens/swap.screen'));
setupLanguages();
export const Routes = [
    {
        path: '/',
        element: _jsx(HomeScreen, {}),
        errorElement: _jsx(ErrorScreen, {}),
    },
    {
        path: '/login',
        element: _jsx(HomeScreen, {}),
    },
    {
        path: '/connect',
        element: _jsx(HomeScreen, {}),
    },
    {
        path: '/my-dfx',
        element: _jsx(HomeScreen, {}),
    },
    {
        path: '/buy',
        element: _jsx(BuyScreen, {}),
    },
    {
        path: '/buy/info',
        element: _jsx(BuyInfoScreen, {}),
    },
    {
        path: '/buy/success',
        element: _jsx(BuySuccessScreen, {}),
    },
    {
        path: '/sell',
        element: withSuspense(_jsx(SellScreen, {})),
    },
    {
        path: '/sell/info',
        element: _jsx(SellInfoScreen, {}),
    },
    {
        path: '/swap',
        element: withSuspense(_jsx(SwapScreen, {})),
    },
    {
        path: '/kyc',
        element: _jsx(KycScreen, {}),
        isKycScreen: true,
    },
    {
        path: '/kyc/redirect',
        element: _jsx(KycRedirectScreen, {}),
        isKycScreen: true,
    },
    {
        path: '/profile',
        element: _jsx(KycScreen, {}),
        isKycScreen: true,
    },
    {
        path: '/contact',
        element: _jsx(KycScreen, {}),
        isKycScreen: true,
    },
    {
        path: '/link',
        element: _jsx(LinkScreen, {}),
        isKycScreen: true,
    },
    {
        path: '/2fa',
        element: _jsx(TfaScreen, {}),
        isKycScreen: true,
    },
    {
        path: '/limit',
        element: _jsx(LimitScreen, {}),
        isKycScreen: true,
    },
    {
        path: '/tx',
        element: _jsx(TransactionScreen, {}),
    },
    {
        path: '/tx/:id',
        element: _jsx(TransactionScreen, {}),
    },
    {
        path: '/tx/:id/assign',
        element: _jsx(TransactionScreen, {}),
    },
    {
        path: '/tx/:id/issue',
        element: _jsx(SupportIssueScreen, {}),
    },
    {
        path: 'support/issue',
        element: _jsx(SupportIssueScreen, {}),
    },
    {
        path: '/bank-accounts',
        element: _jsx(BankAccountsScreen, {}),
    },
];
export var Service;
(function (Service) {
    Service["BUY"] = "buy";
    Service["SELL"] = "sell";
    Service["SWAP"] = "swap";
    Service["CONNECT"] = "connect";
})(Service || (Service = {}));
function App({ routerFactory, params }) {
    const router = routerFactory(Routes);
    const home = (params === null || params === void 0 ? void 0 : params.service) && `/${params.service}`;
    if (home)
        router.navigate(home);
    return (_jsx(DfxContextProvider, Object.assign({ api: {}, data: {}, includePrivateAssets: true }, { children: _jsx(BalanceContextProvider, { children: _jsx(AppHandlingContextProvider, Object.assign({ isWidget: params != null, service: params === null || params === void 0 ? void 0 : params.service, closeCallback: params === null || params === void 0 ? void 0 : params.onClose, params: params, router: router }, { children: _jsx(SettingsContextProvider, { children: _jsx(WalletContextProvider, Object.assign({ router: router }, { children: _jsx(RouterProvider, { router: router }) })) }) })) }) })));
}
function withSuspense(WrappedComponent) {
    return _jsx(Suspense, Object.assign({ fallback: _jsx(SuspenseFallback, {}) }, { children: WrappedComponent }));
}
function SuspenseFallback() {
    return (_jsx(Layout, { children: _jsx(StyledLoadingSpinner, { size: SpinnerSize.LG }) }));
}
export default App;
